import React from 'react';
import { Typography } from '@mui/material';
import { useGetFormConfigQuery } from '@/features/config/configApi';

const DataGridReferralStatus = ({ fieldName, row }) => {
	const { data: fields } = useGetFormConfigQuery({ configType: 'client' });
	const field = fields?.find((f) => f.name === fieldName);
	const label = (field?.field?.options ?? []).find((o) => o.value === row[fieldName])?.label;

	return <Typography>{label ?? row[fieldName] ?? '-'}</Typography>;
};

export default DataGridReferralStatus;
